<template>
    <div class="home">
        <customers />
    </div>
</template>

<script>
    import Customers from "../components/views/Customers";
    export default {
        name: "CustomersView",
        components: {Customers}
    }
</script>

<style scoped>

</style>
